import axios from '@/plugin/axios';
import processError from './ProcessError';

const loginUrlOrg = './login/organization/';
const loginUrlUser = './auth/login/';
const loginUrlAdmin = './login/admin/';
const regUrl = './users/';
const refreshUrl = './auth/token/refresh/'; // check this for fast API
const activateEndpoint = './users/activate/';
const forgotEndpoint = './account/forgot_password'; // check this for fast API
// const resetEndpoint = './account/reset_password';

/**
 * Retrieves login access token/data from api for different user categories
 * @param {object} LoginDetails
 * @returns {Promise<object>}
 */
const Login = (LoginDetails) =>
  new Promise((resolve, reject) => {
    // alert(LoginDetails.type)
    // console.log(user);

    if (LoginDetails.type === 'user') {
      axios
        .post(loginUrlUser, LoginDetails)
        .then((response) => {
          const { data } = response;
          console.log(data, '"response');

          if (data.tokens) {
            localStorage.setItem('access_token', data.tokens.access);
            localStorage.setItem('user', JSON.stringify(data.data));
            localStorage.setItem('refresh_token', data.tokens.refresh);
          }
          resolve(response);
        })
        .catch((error) => {
          processError(error);
          reject(error);
        });
    }

    if (LoginDetails.type === 'organization') {
      axios
        .post(loginUrlOrg, LoginDetails)
        .then((response) => {
          const { data } = response;
          if (data.token) {
            localStorage.setItem('access_token', data.token);
            localStorage.setItem('refresh_token', data.token);
            localStorage.setItem('user', JSON.stringify(data.data));
          }
          resolve(response);
        })
        .catch((error) => {
          processError(error);
          reject(error);
        });
    }

    if (LoginDetails.type === 'admin') {
      axios
        .post(loginUrlAdmin, LoginDetails)
        .then((response) => {
          console.log(response);
          console.log(response, '@response');
          const { data } = response;
          if (data.token) {
            localStorage.setItem('access_token', data.token);
            localStorage.setItem('refresh_token', data.token);
            localStorage.setItem('user', JSON.stringify(data));
          }
          resolve(response);
        })
        .catch((error) => {
          processError(error);
          reject(error);
        });
    }
  });

/**
 * Register a new user
 * @param {*} RegistrationDetails
 * @returns {Promise<object>}
 */
const Registration = (RegistrationDetails) =>
  new Promise((resolve, reject) => {
    // console.log(user);
    axios
      .post(regUrl, RegistrationDetails)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        processError(error);
        reject(error);
      });
  });

/**
 * Clear user authorization
 * @returns {Promise<object>}
 */
const Logout = () =>
  new Promise((resolve) => {
    // console.log(user);
    delete axios.defaults.headers.common.Authorization;
    localStorage.clear();
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('user');
    resolve();
  });

/**
 * Retrieve user info from api
 * @returns {Promise<object>}
 */
const getUserInfo = () =>
  new Promise((resolve, reject) => {
    console.log('fetching user info from API');
    axios
      .post(refreshUrl, {
        refresh: localStorage.getItem('refresh_token'),
      })
      .then((response) => {
        console.log(response);
        resolve(response);
      })
      .catch((error) => {
        processError(error);
        reject(error);
      });
  });

/**
 * Activate user
 * @param {*} Token
 * @returns {Promise<object>}
 */
const ActivateUser = (Token) =>
  new Promise((resolve, reject) => {
    // console.log(user);
    axios
      .post(activateEndpoint, {
        encoded_token: Token,
      })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        processError(error);
        reject(error);
      });
  });

/**
 * Resolve forgot password
 * @param {*} Token
 * @returns {Promise<object>}
 */
const ForgotPasssword = (Token) =>
  new Promise((resolve, reject) => {
    // console.log(user);
    axios
      .post(forgotEndpoint, {
        encoded_token: Token,
      })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        processError(error);
        reject(error);
      });
  });

export default {
  Login,
  Registration,
  Logout,
  getUserInfo,
  ActivateUser,
  ForgotPasssword,
};
